import $ from "jquery";

export default {
  data: function data() {
    return {
      mediaBase: process.env.VUE_APP_MEIDA_URL,
      baseUrl: process.env.VUE_APP_APP_URL
    };
  },
  mounted() {
    let bgImage = this.mediaBase + "/bg/ARKAPLAN.png";
    let ktContent = $("#kt_content");

    ktContent.css({
      backgroundImage: "url('" + bgImage + "')"
    });
  }
};
